import { useQueryGrid } from '@gogame/query';
import { loadMessages } from 'scenes/AIChatbot/sources/messages';
import { messages } from './queryKeyFactory';

export const useLoadMessages = (chatId) => {
  return useQueryGrid(
    messages(chatId),
    (_, { signal }) => loadMessages({ chatId }, { signal }),
    { enabled: !!chatId, keepPreviousData: true, initialData: [] }
  );
};
